/*=========================================================================================
  File Name: state.js
  Description: Orders Actions
  ----------------------------------------------------------------------------------------
  Item Name: Orders State Module
  Author: Tan Tran
==========================================================================================*/
import queries from '../../../services/orders/queries'
import TimeFormatter from '../../../common/utils/TimeFormatter'

export default {

  async getOrdersByDateAndRestaurantAction( {commit, state, rootState }, payload ) {

    let restaurantId = rootState.auth.auth.restaurantId;
    let token = rootState.auth.auth.token;

    await queries.getOrdersByDateAndRestaurantId(restaurantId, payload.createdDate, token)
                 .then( data => {
                  console.log(data)
                   commit('SET_ORDERS_STATE', data)
                 });
  }

}